import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createCustomerSegment = createAsyncThunk("createCustomerSegment", async ({ values, channel_uuid }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`customer-segment`, { ...values, channel_uuid });
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CustomerSegmentCreateSlice = createSlice({
	name: "CustomerSegmentCreateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateCustomerSegmentState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createCustomerSegment.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createCustomerSegment.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createCustomerSegment.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateCustomerSegmentState } = CustomerSegmentCreateSlice.actions;

export default CustomerSegmentCreateSlice.reducer;
